import styled from 'styled-components'
import { t } from 'ttag'

import { Text } from '@h2/components/typography/text'
import { Flex } from '@h2/components/layout/flex'
import { Box } from '@h2/components/layout/box'
import { PG } from '@h2/components/colors'
import { features } from '@h2/components/media'

const Wrap = styled(Box)`
  > :nth-child(2) {
    > div {
      width: calc(50% - 10px);
      height: 100px;
      @media (${features.minWidth.widescreen}) {
        width: calc(25% - 10px);
      }
    }
  }
`
const ClickText = styled.span`
  display: inline;
  cursor: pointer;
  color: ${PG};
  font-weight: 600;
`
const FullWidth = ({ allUsers, setAllUsers, canToggle, children }) => (
  <Wrap>
    <Flex margin="5px 0">
      <Text size="medium" margin="0">
        {allUsers
          ? t`These statistics include activity from all site users in the current program year.`
          : t`These statistics include only your users activity in the current program year.`}
        &nbsp;
        {canToggle && (
          <ClickText onClick={() => setAllUsers(!allUsers)}>
            {allUsers ? t`View only your users.` : t`View all users.`}
          </ClickText>
        )}
      </Text>
    </Flex>
    <Flex justifyContent="space-between" gap="10px" wrap="wrap">
      {children}
    </Flex>
  </Wrap>
)

export { FullWidth }
